import { EnumType } from '../../types';
import { PushEvent } from '../TagManager';

type EstimatorAction = EnumType<
  Pick<
    Extract<Parameters<typeof PushEvent>[0], { eventCategory: 'Valutatore' }>,
    'eventAction'
  >
>;

export function sendGTMEstimator(
  event: EstimatorAction,
  label: string
): void {
  PushEvent({
    event: 'GAevent',
    eventCategory: 'Valutatore',
    eventAction: event,
    eventLabel: label,
  });
}
